import script from "./MainBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBanner.vue?vue&type=script&setup=true&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=561396cc&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Vue-Projects\\ForestPage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561396cc"]])

export default __exports__